import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Button, Pagination, Modal, Image, InputGroup, Form } from 'react-bootstrap';
import { LanguageProvider } from '../core/language-provider';
import { DataManager } from '../core/data-manager';
import { ApiManager } from '../core/api-manager';
import { ResourceManager } from '../core/resource-manager';
import { Helmet } from 'react-helmet';
import banner from '../assets/continue/banner.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CardEventoV2 from '../components/Card/EventoV2';
import { ViewManager } from '../core/view-manager';
import { Utils } from '../core/utils';




export default function Events() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const [dataV2, setDataV2] = useState(null);
    const [search, setSearch] = useState("");
    const [categoryID, setCategoryID] = useState([]);
    const [categoryList, setCategoryList] = useState(null);
    const [showModal, setShowModal] = useState(null);
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [limit, setLimit] = useState(12)


    useEffect(() => {
        getEventV2()
        getCategory()
    }, []);

    useEffect(() => {
        const timeOutId = setTimeout(() => getEventV2(), 400);
        return () => clearTimeout(timeOutId);
    }, [search]);


    async function getEventV2() {
        let offset = page * limit - limit;
        if (categoryID.length === 0) {
            var body = {
                limit: limit,
                query: search,
                category: null,
                offset: offset
            }
        } else {
            var body = {
                limit: limit,
                query: search,
                category: categoryID.toString(),
                offset: offset
            }
        }
        var response = await ApiManager.sendAuthenticatedRequest('/custom/get_events', body);
        if (response.success === 1) {
            setDataV2(response.body)
            closeModal()
            setTotalPages(response.pages)
            setErrors('')
        } else {
            setDataV2([])
            setErrors(response.message)
            closeModal()
        }
    }


    async function getCategory() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var response = await DataManager.getItems('category', 1, 1000, sorting)
        if (response.success === 1) {
            var t = response.body
            setCategoryList(t)
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }


    function openModal() {
        setShowModal(true)
    }
    function closeModal() {
        setShowModal(false)
    }

    const handleChange = (id) => (event) => {
        if (event.target.checked) {
            if (!categoryID.includes(id)) {
                setCategoryID([...categoryID, id])
            }
        } else {
            setCategoryID(categoryID.filter(item => item !== id));
        }
    }

    function svuota() {
        setCategoryID([])
    }


    //pagination
    function goToPrevPage() {
        if (page > 1) {
            setPage(page - 1)
        }
    }
    function goToNextPage() {
        if (page < totalPages) {
            setPage(page + 1)
        }
    }
    function goToFirstPage() {
        if (page !== 1) {
            setPage(1)
        }
    }
    function goToLastPage() {
        if (page !== totalPages) {
            setPage(totalPages)
        }
    }


    useEffect(() => {
        getEventV2()
    }, [page]);





    if (dataV2) {
        return (
            <>
                <Helmet>
                    <title>{LanguageProvider.get('header.events')}</title>
                </Helmet>

                <Container fluid className='text-white' style={{ backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '100%' }}>
                    <Container fluid={'md'}>
                        <Row style={{ paddingTop: '75px', paddingBottom: '75px' }}>
                            <Col>
                                <h2>{LanguageProvider.get('header.events')}</h2>
                                <h6 style={{ maxWidth: 600 }}>Resta aggiornato sugli appuntamenti in calendario</h6>
                            </Col>
                        </Row>
                    </Container>

                </Container>


                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }


                <Container fluid>
                    <Container fluid={'md'}>
                        <Row className='my-5 justify-content-end'>
                            <Col className='text-end'>
                                <Button variant='primary' className="rounded-pill px-3" onClick={() => openModal()}>Filtri</Button>
                            </Col>
                            {/* Barra di ricerca */}
                            {/* <Col md={3} className='ps-0'>
                                <InputGroup>
                                    <Form.Control style={{ borderStartStartRadius: '20px', borderBottomLeftRadius: '20px', borderColor: 'var(--primary-color)', borderRight: '0' }}
                                        placeholder="Cerca" onChange={(e) => setSearch(e.target.value)}
                                    />
                                    <InputGroup.Text style={{ borderTopRightRadius: '20px', borderBottomRightRadius: '20px', borderLeft: '0', borderColor: 'var(--primary-color)', backgroundColor: 'white' }}>
                                        <FontAwesomeIcon icon='search'></FontAwesomeIcon></InputGroup.Text>
                                </InputGroup>
                            </Col> */}
                        </Row>
                        {dataV2 && dataV2.length > 0 ? (
                            <Row className='mt-5 mb-5'>
                                {dataV2.map((item, j) => {
                                    return (
                                        <Col md={4} xs={12} className='mb-5'>
                                            <CardEventoV2 key={j} data={item}></CardEventoV2>
                                        </Col>

                                    )
                                })}
                            </Row>
                        ) : (
                            <>
                                <p className='text-muted text-center'>Nessun evento trovato.</p>
                            </>
                        )}

                        <Pagination className='mb-5'>
                            <Pagination.First className={page === 1 ? 'disabled' : ''} onClick={goToFirstPage} />
                            <Pagination.Prev className={page <= 1 ? 'disabled' : ''} onClick={goToPrevPage} />
                            <Pagination.Item key={page}>
                                {page}
                            </Pagination.Item>
                            <Pagination.Next className={page >= totalPages ? 'disabled' : ''} onClick={goToNextPage} />
                            <Pagination.Last className={page >= totalPages ? 'disabled' : ''} onClick={goToLastPage} />
                        </Pagination>

                    </Container>

                </Container>


                <Modal show={showModal} onHide={closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Filtri</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {categoryList && categoryList.length > 0 ? (<>
                            {categoryList.map((item, index) => {
                                return (<Form.Check
                                    type={'checkbox'}
                                    id={item.id}
                                    label={item.name}
                                    checked={categoryID.includes(item.id)}
                                    onChange={handleChange(item.id)}
                                />)

                            })}
                        </>) : (<></>)}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-danger" onClick={() => svuota()}>
                            Elimina filtri
                        </Button>
                        <Button variant="primary" onClick={() => getEventV2()}>
                            Cerca
                        </Button>
                    </Modal.Footer>
                </Modal>

            </>
        )
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};